/**
 * Slug utilities — shared between CreateWorkspacePage and backend contract.
 *
 * Valid slug format: 3–120 chars, lowercase letters / numbers / hyphens,
 * no leading or trailing hyphen.
 */

const SLUG_RE = /^[a-z0-9][a-z0-9-]{1,118}[a-z0-9]$/

/**
 * Converts a free-form string into a URL-safe slug suggestion.
 *
 * "Meu Workspace" → "meu-workspace"
 * "Empresa Ação"  → "empresa-acao"
 */
export function toSlug(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip diacritics
    .replace(/[^a-z0-9\s-]/g, '')    // keep letters, numbers, spaces, hyphens
    .trim()
    .replace(/\s+/g, '-')            // spaces → hyphens
    .replace(/-+/g, '-')             // collapse consecutive hyphens
    .replace(/^-+|-+$/g, '')         // strip leading/trailing hyphens
}

/** Returns true when the slug matches the valid format. */
export function isValidSlug(slug: string): boolean {
  return SLUG_RE.test(slug)
}

/**
 * Returns a human-readable validation message, or null when the slug is valid.
 * Use this for inline form feedback.
 */
export function slugValidationMessage(slug: string): string | null {
  if (!slug) return 'O slug é obrigatório.'
  if (slug.length < 3) return 'O slug deve ter pelo menos 3 caracteres.'
  if (slug.length > 120) return 'O slug deve ter no máximo 120 caracteres.'
  if (/[^a-z0-9-]/.test(slug)) return 'Use apenas letras minúsculas, números e hífens.'
  if (/^-|-$/.test(slug)) return 'O slug não pode começar ou terminar com hífen.'
  return null
}
